
/* injects from baggage-loader */

'use strict';

const indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) return i;
  }
  return -1;
};

const moduleAlert = angular.module('create_favorite.section.controller', []);

moduleAlert.controller('CreateFavoriteSectionModal', [
  '$scope', '$state', '$rootScope', '$modalInstance', 'Restangular', "$stateParams", "Section", "$window", "section", "FileUploader",
  ($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, section, FileUploader) => {
    $scope.section = angular.copy(section);
    $scope.previewUrl = '/constructor/editor/assets/images/image-error.svg';

    if (Editor.mode === 'email.page.editor') {
      $scope.section.for_email = true;
    }
    if (Editor.mode === 'lesson.page.editor') {
      $scope.section.for_lms_page = true;
    }

    $scope.close = function() {
      return $modalInstance.dismiss('close');
    };

    $scope.sectionFavoriteUploader = new FileUploader({
      autoUpload: false,
      method: 'PUT',
      alias: 'preview',
      headers: {
        'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
      }
    });

    $scope.sectionFavoriteUploader.onAfterAddingFile = function(item) {
      const types = ['image/jpeg', 'image/png'];

      let ref;
      if (ref = item.file.type, indexOf.call(types, ref) < 0) {
        alert('The file must be png or jpg');
        return false;
      } else {
        if (URL && typeof URL.createObjectURL === 'function') {
          $scope.previewUrl = URL.createObjectURL(item._file);
        }
      }
    };

    $scope.sectionFavoriteUploader.onSuccessItem = function(fileItem, response, status, headers) {
      $scope.previewUrl = response.preview_url;
      $scope.sectionFavoriteUploader.clearQueue();
    };
    $scope.sectionFavoriteUploader.onErrorItem = function(fileItem, response, status, headers) {};

    $scope.save = function(editSectionForm) {
      if (editSectionForm.$invalid) {
        return false;
      }

      $scope.updating = true;

      Section.saveTemplate($scope.section).then(function(sectionData) {
        if ($scope.sectionFavoriteUploader.queue.length > 0) {
          $scope.sectionFavoriteUploader.queue.forEach((item) => {
            item.url = Restangular.configuration.baseUrl + ('/sections/' + sectionData.id);
          });
        }

        $scope.sectionFavoriteUploader.uploadAll();
        $scope.close();
        $scope.updating = false;
      }, function() {
        $scope.updating = false;
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/section_settings/create_favorite.controller.js